<template>
  <app-carousel :item-width="290" :items="list">
    <template #item="{ item }">
      <div class="h-full">
        <teacher-card
          class="w-full"
          :content-visibility="contentVisibility"
          :show-description-short="showDescriptionShort"
          :tag="tag"
          :teacher="item"
          @click="onClick(item)"
        />
      </div>
    </template>
  </app-carousel>
</template>

<script lang="ts" setup>
import type {
  TeacherCardProps,
  TeacherListView,
} from "~/business-areas/teacher/teacher.model";

defineProps<
  {
    list: TeacherListView[];
    loading?: boolean;
  } & TeacherCardProps
>();

const { $analytics } = useNuxtApp();

function onClick(teacher: TeacherListView) {
  return $analytics.track("teacher_clicked", {
    teacher: {
      id: teacher.id,
      full_name: teacher.full_name!,
      slug: teacher.slug!,
    },
  });
}
</script>
